mutation TripUploadDocument($document: DocumentUploadInput!, $tripId: UUID!) {
  tripUploadDocument(document: $document, tripId: $tripId) {
    uploadLink
    document {
      _documentFileId
      tripDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
